/** La pagina Accessi e il catalogo dei permessi (blocco 35). */
export const EN_ACCESSI: Record<string, string> = {
  // Le aree.
  'Organizzazione e persone': 'Organization and people',
  'Server e IP': 'Servers and IPs',
  'Codice e moduli': 'Code and modules',
  'Backup e continuità': 'Backups and continuity',
  'Domini e copie di prova': 'Domains and staging copies',
  'Impostazioni, assistenti e traslochi': 'Settings, assistants and migrations',

  // I permessi: nome, cosa apre, perché sono pericolosi.
  'Vedere l’organizzazione': 'See the organization',
  'Le pagine dell’organizzazione e gli assistenti collegati': 'The organization’s pages and the connected assistants',
  'Cambiare nome e obiettivi': 'Change name and targets',
  'Il nome dell’organizzazione; «Salva» degli obiettivi in Continuità': 'The organization’s name; “Save” for the targets in Continuity',
  'Invitare persone': 'Invite people',
  '«Invita» e la revoca degli inviti in Persone': '“Invite” and revoking invitations in People',
  'Gestire le persone': 'Manage people',
  'La pagina Persone: ruoli, «Rimuovi», accessi sulle risorse, i token di tutti': 'The People page: roles, “Remove”, resource access, everyone’s tokens',
  'Chi gestisce le persone decide chi entra e con quali diritti.': 'Whoever manages people decides who gets in and with which rights.',
  'Nominare e togliere owner': 'Appoint and remove owners',
  'Il ruolo owner negli inviti e nei cambi di ruolo': 'The owner role in invitations and role changes',
  'Un owner governa tutta l’organizzazione.': 'An owner governs the whole organization.',
  'Creare token e collegare assistenti': 'Create tokens and connect assistants',
  'Token API; «Crea il collegamento» in Assistenti': 'API tokens; “Create the connection” in Assistants',
  'Leggere il registro': 'Read the audit log',
  'La pagina Registro': 'The Audit log page',
  'Vedere i server': 'See servers',
  'La pagina Server e la scheda di ogni server': 'The Servers page and each server’s page',
  'Vedere le metriche': 'See metrics',
  'I grafici di CPU, memoria e disco': 'The CPU, memory and disk charts',
  'Creare e collegare server': 'Create and connect servers',
  '«Collega un server», «Crea il server», «Riprendi» la preparazione': '“Connect a server”, “Create the server”, “Resume” the setup',
  'Un server nuovo si paga.': 'A new server costs money.',
  'Scollegare server': 'Disconnect servers',
  '«Scollega» nella scheda del server; «Dichiara il disastro» in Continuità': '“Disconnect” on the server page; “Declare the disaster” in Continuity',
  'Cancella la macchina e tutto quello che ci gira.': 'It deletes the machine and everything running on it.',
  'Dare accesso SSH a tempo': 'Grant time-limited SSH access',
  '«Dai l’accesso» e «Revoca» in Accesso SSH': '“Grant access” and “Revoke” in SSH access',
  'Dà una shell sul server, e da lì si leggono le istanze vicine.': 'It gives a shell on the server, and from there the neighbouring instances can be read.',
  'Vedere gli IP fissi': 'See static IPs',
  'La pagina IP': 'The IP page',
  'Comprare e spostare IP fissi': 'Buy and move static IPs',
  '«Compra e assegna», «Assegna», «Libera»': '“Buy and assign”, “Assign”, “Release”',
  'Un IP si paga, e spostarlo sposta il traffico di un cliente.': 'An IP costs money, and moving it moves a customer’s traffic.',
  'Vedere le istanze': 'See instances',
  'La pagina Istanze e la scheda di ogni istanza': 'The Instances page and each instance’s page',
  'Leggere log e attività': 'Read logs and activity',
  'La pagina Attività e i log delle istanze': 'The Activity page and the instances’ logs',
  'Creare istanze': 'Create instances',
  '«Nuova istanza»': '“New instance”',
  'Avviare un’istanza': 'Start an instance',
  '«Avvia» nella scheda dell’istanza; il tool start_instance': '“Start” on the instance page; the start_instance tool',
  'Fermare un’istanza': 'Stop an instance',
  '«Ferma» nella scheda dell’istanza; il tool stop_instance': '“Stop” on the instance page; the stop_instance tool',
  'Spegne la produzione di un cliente.': 'It shuts down a customer’s production.',
  'Riavviare un’istanza': 'Restart an instance',
  '«Riavvia» nella scheda dell’istanza; il tool restart_instance': '“Restart” on the instance page; the restart_instance tool',
  'Cambiare worker e memoria': 'Change workers and memory',
  '«Modifica» le risorse e «Rigenera la configurazione»': '“Edit” the resources and “Regenerate configuration”',
  'Entrare in Odoo come un utente': 'Sign in to Odoo as a user',
  '«Entra in Odoo»': '“Sign in to Odoo”',
  'Si entra come chiunque, senza password.': 'You get in as anyone, without a password.',
  'Rimuovere un’istanza': 'Remove an instance',
  '«Rimuovi» nella scheda dell’istanza': '“Remove” on the instance page',
  'Cancella database e file dell’istanza.': 'It deletes the instance’s database and files.',
  'Collegare repository e librerie': 'Connect repositories and libraries',
  '«Collega», «Scollega», «Cambia ramo», le librerie Python, il Catalogo': '“Connect”, “Disconnect”, “Change branch”, Python libraries, the Catalog',
  'Il codice gira sul server con i diritti di Odoo.': 'The code runs on the server with Odoo’s rights.',
  'Portare i moduli alla punta del ramo': 'Bring modules to the tip of the branch',
  '«Portalo sul server» e «Aggiorna» in Moduli; ogni riconfigurazione di un’istanza con repository': '“Deploy to server” and “Update” in Modules; every reconfiguration of an instance with repositories',
  'Porta in produzione il codice nuovo dei rami collegati.': 'It brings the new code of the connected branches into production.',
  'Installare moduli': 'Install modules',
  '«Moduli…» nella scheda dell’istanza; i moduli di un blueprint': '“Modules…” on the instance page; a blueprint’s modules',
  'Aggiornare Odoo': 'Update Odoo',
  '«Aggiorna Odoo» e «Attiva Enterprise»': '“Update Odoo” and “Enable Enterprise”',
  'Ferma la produzione e fa migrare il database.': 'It stops production and migrates the database.',
  'Gestire i blueprint': 'Manage blueprints',
  'La pagina Blueprint: «Nuovo blueprint», modifica, «Elimina»': 'The Blueprints page: “New blueprint”, editing, “Delete”',
  'Vedere i backup': 'See backups',
  'Le pagine Backup e Continuità': 'The Backups and Continuity pages',
  'Fare un backup': 'Take a backup',
  '«Backup adesso» e «Prova il ripristino»': '“Back up now” and “Test the restore”',
  'Pianificare i backup': 'Schedule backups',
  '«Attiva» e «Disattiva» la pianificazione': '“Turn on” and “Turn off” the schedule',
  'Disattivarla lascia un’istanza senza backup.': 'Turning it off leaves an instance without backups.',
  'Scaricare un backup': 'Download a backup',
  '«Scarica»': '“Download”',
  'Un backup porta i dati personali dei clienti.': 'A backup carries the customers’ personal data.',
  'Ripristinare in un’istanza nuova': 'Restore into a new instance',
  '«Ripristina»': '“Restore”',
  'Sostituire i dati della produzione': 'Replace production data',
  '«Sostituisci i dati» in produzione': '“Replace the data” in production',
  'I dati di oggi si perdono.': 'Today’s data is lost.',
  'Scegliere dove vanno i backup': 'Choose where backups go',
  '«Nuova destinazione» in Backup': '“New destination” in Backups',
  'Collegare domini': 'Connect domains',
  '«Collega un dominio tuo», «Scollega», «Riprova»': '“Connect your own domain”, “Disconnect”, “Retry”',
  'Creare copie di prova': 'Create staging copies',
  '«Crea» una copia di prova': '“Create” a staging copy',
  'Aggiornare una copia dalla produzione': 'Refresh a copy from production',
  '«Aggiorna dalla produzione»': '“Update from production”',
  'Collegare chiavi cloud e DNS': 'Connect cloud and DNS keys',
  'Progetto OVH e Cloudflare in Impostazioni': 'OVH project and Cloudflare in Settings',
  'Le chiavi creano macchine che si pagano.': 'The keys create machines that cost money.',
  'Gestire Enterprise e catalogo': 'Manage Enterprise and catalog',
  'Enterprise e catalogo dei moduli in Impostazioni': 'Enterprise and the module catalog in Settings',
  'Gestire i recapiti degli avvisi': 'Manage alert contacts',
  'Recapiti in Impostazioni': 'Contacts in Settings',
  'Governare gli assistenti': 'Govern the assistants',
  'Gli interruttori in Assistenti': 'The switches in Assistants',
  'Traslocare da CloudPepper': 'Migrate from CloudPepper',
  'La pagina Traslochi': 'The Migrations page',
  'Collegare una sorgente dà root su una macchina, e un trasloco spegne la produzione.': 'Connecting a source gives root on a machine, and a migration shuts production down.',

  // La pagina.
  'Accessi': 'Access',
  'Permesso': 'Permission',
  'Cliente · admin': 'Customer · admin',
  'Cliente · operatore': 'Customer · operator',
  'Cliente · lettura': 'Customer · read',
  'Il proprietario tiene sempre le persone: senza, l’organizzazione resterebbe senza nessuno che la gestisca.':
    'The owner always keeps people management: without it, nobody would be left to manage the organization.',
  'Un accesso su un’istanza o un server dà solo permessi su quella risorsa, non sull’organizzazione.':
    'Access on an instance or a server only grants permissions on that resource, not on the organization.',
  '«{permesso}» concesso a {colonna}': '“{permesso}” granted to {colonna}',
  '«{permesso}» tolto a {colonna}': '“{permesso}” removed from {colonna}',
  'Tutti i permessi sono tornati come di serie': 'All permissions are back to the defaults',
  'Di serie: {valore} · cambiato da {chi} il {quando}': 'Default: {valore} · changed by {chi} on {quando}',
  'sì': 'yes',
  'no': 'no',
  'qualcuno': 'someone',
  'Diverso da come nasce': 'Different from the default',
  'Cosa vede e cosa usa ogni ruolo, in tutte le organizzazioni di questo Molo. Concedere a una colonna concede anche a quelle a sinistra; togliere toglie anche a quelle a destra. Ogni modifica finisce nel registro di ogni organizzazione.':
    'What each role sees and uses, in every organization on this Molo. Granting to a column also grants to the ones on its left; removing also removes from the ones on its right. Every change ends up in every organization’s audit log.',
  'Non riesco a leggere la matrice': 'I can’t read the matrix',
  'Modifica non applicata': 'Change not applied',
  'Tutto come di serie.': 'Everything as by default.',
  'Una casella diversa da come Molo nasce.': 'One cell differs from Molo’s defaults.',
  '{n} caselle diverse da come Molo nasce.': '{n} cells differ from Molo’s defaults.',
  'Torna come di serie': 'Back to defaults',
  'Pericoloso': 'Dangerous',
  'Concedere «{permesso}» a {colonna}?': 'Grant “{permesso}” to {colonna}?',
  'Vale in tutte le organizzazioni, e anche per le colonne a sinistra.': 'It applies in every organization, and to the columns on the left too.',
  'Tornare come di serie?': 'Back to defaults?',
  'Ogni casella cambiata torna com’è scritta in Molo, in tutte le organizzazioni.': 'Every changed cell goes back to how Molo ships it, in every organization.',

  // Il registro.
  'Ha concesso {permesso} a {colonna}, in tutte le organizzazioni': 'Granted {permesso} to {colonna}, in every organization',
  'Ha tolto {permesso} a {colonna}, in tutte le organizzazioni': 'Removed {permesso} from {colonna}, in every organization',
  'Ha riportato i permessi come di serie, in tutte le organizzazioni': 'Put permissions back to the defaults, in every organization',

  // Un pulsante disabilitato.
  'Serve «{permesso}», che qui non hai.': 'This needs “{permesso}”, which you don’t have here.',
};
